module.exports = __webpack_public_path__ + "img/step.656769d4.png";